import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'clicks',
        label: t('chart.avgClicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: t('chart.avgImpressions'),
        icon: 'search',
    },
    {
        key: 'position',
        label: t('chart.avgPosition'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
    {
        key: 'ctr',
        label: t('chart.avgCTR'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'keywords',
        label: t('chart.avgKeywords'),
        yAxisID: 'y4',
        icon: 'pagev-view',
    },
];

export default keys;
